export default "__VITE_ASSET__4a2bffce__"